import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = {
  key: 0,
  class: "overflow-auto pb-5"
}
const _hoisted_4 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-7 align-center" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"overlay me-10\"><div class=\"overlay-wrapper\"></div></div><div class=\"overlay me-10\"><div class=\"overlay-wrapper\"><img src=\"https://images.empoweredconsumerism-static-files.com/ovi/sealpro/seal_pro_banner.jpg\" style=\"max-height:400px;\"></div></div><div class=\"overlay me-10\"><div class=\"overlay-wrapper\"></div></div><div class=\"overlay me-10\"><div class=\"overlay-wrapper\"></div></div>", 4)
const _hoisted_9 = { class: "overlay me-10" }
const _hoisted_10 = { class: "overlay-wrapper" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", {
  class: "col-lg-12 col-form-label row fw-bold fs-2 text-center",
  style: {"padding-top":"50px","padding":"right:50px"}
}, [
  /*#__PURE__*/_createVNode("b", null, "Your maximum coverage is :")
], -1)
const _hoisted_12 = { class: "col-lg-12 col-form-label row fw-bold fs-1 text-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "overlay me-10" }, [
  /*#__PURE__*/_createVNode("div", { class: "overlay-wrapper" })
], -1)
const _hoisted_14 = {
  class: "timeline-content mb-10 mt-n1",
  style: {"display":"none"}
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "pe-3 mb-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "fs-5 fw-bold mb-2" }, " Active Coverages ")
], -1)
const _hoisted_16 = { class: "overflow-auto pb-5" }
const _hoisted_17 = { class: "d-flex  align-items-center border border-dashed border-gray-300 rounded  min-w-750px px-7 py-3 mb-5" }
const _hoisted_18 = { class: " symbol-group symbol-hover flex-nowrap flex-grow-1 min-w-100px  pe-2 " }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "card-header align-items-center border-0 mt-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "fw-bolder text-dark" }, "Coverages Details"),
    /*#__PURE__*/_createVNode("span", { class: "text-muted mt-1 fw-bold fs-7" })
  ])
], -1)
const _hoisted_21 = { class: "card-body pt-3" }
const _hoisted_22 = { class: "symbol symbol-150px me-5" }
const _hoisted_23 = { class: "d-flex flex-row-fluid align-items-center flex-wrap my-lg-0 me-2" }
const _hoisted_24 = { class: "flex-grow-1 my-lg-0 my-2 me-2" }
const _hoisted_25 = {
  href: "#",
  class: "text-gray-800 fw-bolder text-hover-primary fs-6"
}
const _hoisted_26 = { class: "text-muted fw-bold d-block pt-1" }
const _hoisted_27 = {
  key: 0,
  class: "d-block badge badge-light-danger"
}
const _hoisted_28 = {
  key: 1,
  class: "d-block badge badge-light-warning"
}
const _hoisted_29 = {
  key: 2,
  class: "d-block badge badge-light-success"
}
const _hoisted_30 = {
  key: 0,
  class: "d-flex flex-center flex-row-fluid"
}
const _hoisted_31 = {
  type: "button",
  ref: "renewNowSealproModalButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#renew_now_sealpromodal`
}
const _hoisted_32 = {
  type: "button",
  ref: "renewNowSealproModalButton2",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#encode_renewal_sealpromodal`
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_font = _resolveComponent("font")
  const _component_SealProRenew = _resolveComponent("SealProRenew")
  const _component_SealProEncode = _resolveComponent("SealProEncode")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        _createVNode("div", _hoisted_2, [
          (Number(_ctx.sealProMaxCoverage) > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode("label", _hoisted_12, [
                        _createVNode("b", null, [
                          _createVNode(_component_font, {
                            color: "green",
                            size: "5"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.numberWithCommas(Number(_ctx.sealProMaxCoverage).toFixed(2))), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_13
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activeCoverage, (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "symbol symbol-150px symbol-lg-180px symbol-fixed position-relative",
                      key: index
                    }, [
                      _createVNode("img", {
                        src: '/media/ovi_coverages/' + item.packageType + '.webp',
                        alt: "img"
                      }, null, 8, ["src"])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode("div", _hoisted_21, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activeCoverage, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: [{ 'mb-7': _ctx.activeCoverage.length - 1 !== index }, "d-flex align-items-sm-center "]
                }, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", {
                      class: "symbol-label",
                      style: `background-image: url('/media/ovi_coverages/${item.packageType}.webp')`
                    }, null, 4)
                  ]),
                  _createVNode("div", _hoisted_23, [
                    _createVNode("div", _hoisted_24, [
                      _createVNode("a", _hoisted_25, "ECOC: " + _toDisplayString(item.coi), 1),
                      _createVNode("span", _hoisted_26, _toDisplayString(_ctx.numberWithCommas(Number(item.amount).toFixed(2))), 1),
                      (item.coveragests === 'EXPIRED')
                        ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(_ctx.formatDate(item.form_date)) + " - " + _toDisplayString(_ctx.formatDate(item.expire_date)), 1))
                        : (item.coveragests === 'EXPIRING')
                          ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(_ctx.formatDate(item.form_date)) + " - " + _toDisplayString(_ctx.formatDate(item.expire_date)), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.formatDate(item.form_date)) + " - " + _toDisplayString(_ctx.formatDate(item.expire_date)), 1))
                    ]),
                    (item.coveragests === 'EXPIRED' || item.coveragests === 'EXPIRING')
                      ? (_openBlock(), _createBlock("div", _hoisted_30, [
                          _createVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.renewSealPro(item)),
                            class: "btn btn-primary"
                          }, " Renew Policy ", 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _withDirectives(_createVNode("button", _hoisted_31, " Click here ", 512), [
            [_vShow, false]
          ]),
          _createVNode(_component_SealProRenew, {
            key: _ctx.renew_now_sealpro_key,
            renewCoverage: _ctx.renewCoverage,
            sealpro_encode_modal: 'renew_now_sealpromodal'
          }, null, 8, ["renewCoverage"]),
          _withDirectives(_createVNode("button", _hoisted_32, " Click here ", 512), [
            [_vShow, false]
          ]),
          _createVNode(_component_SealProEncode, {
            key: _ctx.renew_now_sealpro_key,
            firstCoverage: _ctx.renewCoverage,
            sealpro_encode_modal: 'encode_renewal_sealpromodal',
            isRenewal: true,
            allowClose: true,
            inputActivationDetail: false,
            isAddAccount: false,
            allowChangeName: false
          }, null, 8, ["firstCoverage"])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}